export default "__VITE_ASSET__SmyP625g__"